import ViewBase from '../framework/core/mvvm/view_base';



const { ccclass, menu, property, executeInEditMode, inspector } = cc._decorator;

@ccclass
@menu('UI/USprite')
@executeInEditMode
export default class USprite extends cc.Component {

    @property(ViewBase)
    viewBase: ViewBase = null;

    private _init: boolean
    private targetComponent: cc.Sprite

    @property()
    public i18nKey: string = ""

    public changeLanguage() {

    }

    onEnable() {
        if (!this._init) {
            this._init = true
            this.targetComponent = this.getComponent<cc.Sprite>(cc.Sprite)
            if (this.viewBase) {
                this.viewBase.cacheComponent(this.node.name, this)
            }
        }
    }

    protected resetInEditor() {
        if (this.viewBase == null) {
            let parent = this.node
            while (parent != null) {
                this.viewBase = parent.getComponent<ViewBase>(ViewBase)
                if (this.viewBase != null) {
                    break;
                }
                parent = parent.parent
            }
        }
    }
}
